import React from 'react'
import PropTypes from 'prop-types'

export const Badge = (props) => {
  return <div>
    { 
      props.isSuccess
        ? <div className="upload-result upload-success-badge">
          <div className="upload-result upload-badge-text"> 
            Success! {props.succeeded.length} schedule{props.succeeded.length > 1 ? 's' : ''} {props.succeeded.length > 1 ? 'were' : 'was'} created. 
          </div>
        </div>
        : <div>
          <div className="upload-result upload-failure-badge">
            <div className="upload-result upload-badge-text"> 
                Error occured: {props.scheduleUploadError}
            </div>
          </div>
          <button 
            className="btn btn-link upload-result upload-failure-sub-text" 
            onClick={() => props.onServerError()}>Please go back and try again</button>
        </div>
    }
  </div>
}

Badge.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  succeeded: PropTypes.array,
  scheduleUploadError: PropTypes.string,

  onServerError: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/restaurantPoolSchedule/badge.js